const AbstractDojoRequestRecord = require('./AbstractDojoRequestRecord');
const DojoConfig = require('../../DojoConfig');

class DojoTransactionSignatureRequestRecord extends AbstractDojoRequestRecord {
    /**
     * @param {DojoConfig} config
     * @param {string} requestId
     * @param {boolean} accepted
     */
    constructor(config, requestId, accepted = false) {
        if (!(config instanceof DojoConfig)) {
            throw new Error('Required instance of DojoConfig is missing');
        }
        if (!requestId) {
            throw new Error('requestId is required');
        }
        const url = 'pac/terminals/' + config.terminalId + '/transactions/' + requestId + '/signature';
        super(
            'PUT',
            url
        );
        this.data = {
            accepted: !!accepted,
        };
    }
}

module.exports = DojoTransactionSignatureRequestRecord;
